module.exports = __webpack_public_path__ + "img/markets-ferrero.03a83f60.jpg";